const amount = (value) => {
  // TODO: end locale-ees xamaarch orchuulga oruulj too shirxegiin orchuulgiig butsaadag bolgox
  const amount = {
    mn: 'ш',
    en: 'pcs',
  }
  try {
    return `${value} ${amount.mn}`;
  } catch (e) {
    console.error(e);
    return value;
  }
}

export { amount }
